import * as React from "react";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { CircularProgress } from "@mui/material";
import {
  AddEmailSettingApi,
  emailSettingApi,
} from "src/DAL/ClientSetting/ClientSetting";
import { s3baseUrl } from "src/config/config";
import { useEffect } from "react";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const Input = styled("input")({
  display: "none",
});

export default function EmailSetting() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [file, setProfileImage] = useState();
  const [fb, setFBImage] = useState();
  const [instagram, setInstagramImage] = useState();
  const [linkedInImage, setLinkedInImage] = useState();
  const [twitterImage, setTwitterImage] = useState();
  const [oldFb, setOldFb] = useState("");
  const [oldLinkedIn, setOldLinkedIn] = useState("");
  const [oldTwitter, setOldTwitter] = useState("");
  const [oldInstagram, setOldInstagram] = useState("");
  const [oldEmailBrandLogo, setOldEmailBrandLogo] = useState("");

  const [inputs, setInputs] = useState({
    image: {},
    fbLink: "",
    instagramIcon: {},
    facebookIcon: {},
    twitterIcon: {},
    linkedInIcon: {},
    email: "",
    contactLink: "",
    address: "",
    name: "",
    faqLink: "",
    copyRightText: "",
    teamName: "",
    twLink: "",
    instaLink: "",
    linkedinLink: "",
    supportName: "",
  });

  const siteSettingData = async () => {
    setIsLoading(true);
    const result = await emailSettingApi();
    if (result.code == 200) {
      setInputs({
        ...inputs,
        ["contactLink"]: result?.email_setting?.contact_us_link,
        ["fbLink"]: result?.email_setting?.facebook_link,
        ["email"]: result?.email_setting?.support_email,
        ["address"]: result?.email_setting?.office_address,
        ["name"]: result?.email_setting?.team_name,
        ["faqLink"]: result?.email_setting?.faq_link,
        ["copyRightText"]: result?.email_setting?.copy_right_text,
        ["teamName"]: result?.email_setting?.team_name,
        ["twLink"]: result?.email_setting?.twitter_link,
        ["instaLink"]: result?.email_setting?.instagram_link,
        ["linkedinLink"]: result?.email_setting?.linkedin_link,
        ["supportName"]: result?.email_setting?.support_name,
      });
      setOldInstagram(result?.email_setting?.instagram_icon?.thumbnail_1);
      setOldLinkedIn(result?.email_setting?.linkedin_icon?.thumbnail_1);
      setOldTwitter(result?.email_setting?.twitter_icon?.thumbnail_1);
      setOldFb(result?.email_setting?.facebook_icon?.thumbnail_1);
      setOldEmailBrandLogo(result?.email_setting?.email_brand_logo);
      setIsLoading(false);
    }
  };

  const fileChangedHandler = (e) => {
    setProfileImage(URL.createObjectURL(e.target.files[0]));
    setInputs({
      ...inputs,
      ["image"]: e.target.files[0],
    });
  };
  const fileChangedHandlerFB = (e) => {
    setFBImage(URL.createObjectURL(e.target.files[0]));
    setInputs({
      ...inputs,
      ["facebookIcon"]: e.target.files[0],
    });
  };
  const fileChangedHandlerInsta = (e) => {
    setInstagramImage(URL.createObjectURL(e.target.files[0]));
    setInputs({
      ...inputs,
      ["instagramIcon"]: e.target.files[0],
    });
  };
  const fileChangedHandlerTwitter = (e) => {
    setTwitterImage(URL.createObjectURL(e.target.files[0]));
    setInputs({
      ...inputs,
      ["twitterIcon"]: e.target.files[0],
    });
  };

  const fileChangedHandlerLinkedIn = (e) => {
    setLinkedInImage(URL.createObjectURL(e.target.files[0]));
    setInputs({
      ...inputs,
      ["linkedInIcon"]: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("support_email", inputs.email);
    formData.append("support_name", inputs.supportName);
    formData.append("contact_us_link", inputs.contactLink);
    formData.append("faq_link", inputs.faqLink);
    formData.append("copy_right_text", inputs.copyRightText);
    formData.append("office_address", inputs.address);
    formData.append("team_name", inputs.name);
    formData.append("facebook_link", inputs.fbLink);
    formData.append("instagram_link", inputs.instaLink);
    formData.append("twitter_link", inputs.twLink);
    formData.append("linkedin_link", inputs.linkedinLink);

    if (fb) {
      formData.append("facebook_icon", inputs.facebookIcon);
    }
    if (instagram) {
      formData.append("instagram_icon", inputs.instagramIcon);
    }
    if (twitterImage) {
      formData.append("twitter_icon", inputs.twitterIcon);
    }
    if (linkedInImage) {
      formData.append("linkedin_icon", inputs.linkedInIcon);
    }
    if (file) {
      formData.append("email_brand_logo", inputs.image);
    }

    setIsLoading(true);
    const result = await AddEmailSettingApi(formData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  useEffect(() => {
    siteSettingData();
  }, []);

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container">
      <div className="row mobile-margin display-flex">
        <div className="col-12"></div>
      </div>
      <div className="row">
        <div className="col-6">
          <h2>Email Setting</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
          <TextField
            id="outlined-basic"
            label="Email"
            variant="outlined"
            fullWidth
            name="email"
            required
            value={inputs.email}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
          <TextField
            id="outlined-basic"
            label="Contact Link"
            variant="outlined"
            fullWidth
            required
            name="contactLink"
            value={inputs.contactLink}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
          <TextField
            id="outlined-basic"
            label="Office Address"
            variant="outlined"
            fullWidth
            name="address"
            value={inputs.address}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
          <TextField
            id="outlined-basic"
            label="Faq Link"
            variant="outlined"
            fullWidth
            name="faqLink"
            value={inputs.faqLink}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
          <TextField
            id="outlined-basic"
            label="CopyRight Text"
            variant="outlined"
            fullWidth
            name="copyRightText"
            value={inputs.copyRightText}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
          <div className="row w-100 div-style ms-0 pt-0">
            <div className="col-5">
              <p className="">Email Brand Logo *</p>
              <FormHelperText className="pt-0">
                ("PNG",300 X 300)
              </FormHelperText>
            </div>
            <div className="col-2">
              {file ? (
                <img className="image-border" src={file} height="50" />
              ) : (
                <img
                  className="image-border"
                  src={s3baseUrl + oldEmailBrandLogo}
                  height="50"
                />
              )}
            </div>
            <div className="col-5 text-end pt-2">
              <label htmlFor="contained-button-file">
                <Input
                  accept="image/*"
                  id="contained-button-file"
                  multiple
                  type="file"
                  name="image"
                  onChange={fileChangedHandler}
                />

                <Button
                  className="small-contained-button"
                  startIcon={<FileUploadIcon />}
                  component="span"
                >
                  Upload
                </Button>
              </label>
            </div>
          </div>
          {inputs.image.name == "" ? (
            ""
          ) : (
            <p className="text-secondary">{inputs.image.name}</p>
          )}
        </div>
        <h3 className="mt-5">Social Media</h3>

        <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
          <TextField
            id="outlined-basic"
            label="Facebook link"
            variant="outlined"
            fullWidth
            name="fbLink"
            value={inputs.fbLink}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
          <TextField
            id="outlined-basic"
            label="Twitter Link"
            variant="outlined"
            fullWidth
            name="twLink"
            value={inputs.twLink}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
          <TextField
            id="outlined-basic"
            label="Instagram link"
            variant="outlined"
            fullWidth
            name="instaLink"
            value={inputs.instaLink}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
          <TextField
            id="outlined-basic"
            label="Linkedin Link"
            variant="outlined"
            fullWidth
            name="linkedinLink"
            value={inputs.linkedinLink}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
          <div className="row w-100 div-style ms-0 pt-0">
            <div className="col-5">
              <p className="">Facebook icon</p>
              <FormHelperText className="pt-0">
                ( "PNG",778 X 430)
              </FormHelperText>
            </div>
            <div className="col-2">
              {fb ? (
                <img className="image-border" src={fb} height="50" />
              ) : (
                <img
                  className="image-border"
                  src={s3baseUrl + oldFb}
                  height="50"
                />
              )}
            </div>
            <div className="col-5 text-end pt-2">
              <label htmlFor="contained-button-fileFb">
                <Input
                  accept="image/*"
                  id="contained-button-fileFb"
                  multiple
                  type="file"
                  name="facebookIcon"
                  onChange={fileChangedHandlerFB}
                />

                <Button
                  className="small-contained-button"
                  startIcon={<FileUploadIcon />}
                  component="span"
                >
                  Upload
                </Button>
              </label>
            </div>
          </div>
          {inputs.image.name == "" ? (
            ""
          ) : (
            <p className="text-secondary">{inputs.image.name}</p>
          )}
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
          <div className="row w-100 div-style ms-0 pt-0">
            <div className="col-5">
              <p className="">Instagram icon</p>
              <FormHelperText className="pt-0">
                ( "PNG",778 X 430)
              </FormHelperText>
            </div>
            <div className="col-2">
              {instagram ? (
                <img className="image-border" src={instagram} height="50" />
              ) : (
                <img
                  className="image-border"
                  src={s3baseUrl + oldInstagram}
                  height="50"
                />
              )}
            </div>
            <div className="col-5 text-end pt-2">
              <label htmlFor="contained-button-fileInstagram">
                <Input
                  accept="image/*"
                  id="contained-button-fileInstagram"
                  multiple
                  type="file"
                  name="instagramIcon"
                  onChange={fileChangedHandlerInsta}
                />

                <Button
                  className="small-contained-button"
                  startIcon={<FileUploadIcon />}
                  component="span"
                >
                  Upload
                </Button>
              </label>
            </div>
          </div>
          {inputs.image.name == "" ? (
            ""
          ) : (
            <p className="text-secondary">{inputs.image.name}</p>
          )}
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
          <div className="row w-100 div-style ms-0 pt-0">
            <div className="col-5">
              <p className="">Twitter icon</p>
              <FormHelperText className="pt-0">
                ( "PNG",778 X 430)
              </FormHelperText>
            </div>
            <div className="col-2">
              {twitterImage ? (
                <img className="image-border" src={twitterImage} height="50" />
              ) : (
                <img
                  className="image-border"
                  src={s3baseUrl + oldTwitter}
                  height="50"
                />
              )}
            </div>
            <div className="col-5 text-end pt-2">
              <label htmlFor="contained-button-fileTwitter">
                <Input
                  accept="image/*"
                  id="contained-button-fileTwitter"
                  multiple
                  type="file"
                  name="twitterIcon"
                  onChange={fileChangedHandlerTwitter}
                />

                <Button
                  className="small-contained-button"
                  startIcon={<FileUploadIcon />}
                  component="span"
                >
                  Upload
                </Button>
              </label>
            </div>
          </div>
          {inputs.image.name == "" ? (
            ""
          ) : (
            <p className="text-secondary">{inputs.image.name}</p>
          )}
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
          <div className="row w-100 div-style ms-0 pt-0">
            <div className="col-5">
              <p className="">LinkedIn icon</p>
              <FormHelperText className="pt-0">
                ( "PNG",778 X 430)
              </FormHelperText>
            </div>
            <div className="col-2">
              {linkedInImage ? (
                <img className="image-border" src={linkedInImage} height="50" />
              ) : (
                <img
                  className="image-border"
                  src={s3baseUrl + oldLinkedIn}
                  height="50"
                />
              )}
            </div>
            <div className="col-5 text-end pt-2">
              <label htmlFor="contained-button-fileLinkedIn">
                <Input
                  accept="image/*"
                  id="contained-button-fileLinkedIn"
                  multiple
                  type="file"
                  name="LinkedInIcon"
                  onChange={fileChangedHandlerLinkedIn}
                />

                <Button
                  className="small-contained-button"
                  startIcon={<FileUploadIcon />}
                  component="span"
                >
                  Upload
                </Button>
              </label>
            </div>
          </div>
          {inputs.image.name == "" ? (
            ""
          ) : (
            <p className="text-secondary">{inputs.image.name}</p>
          )}
        </div>

        <div className="text-end mt-4">
          <button onClick={handleSubmit} className="small-contained-button">
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
